{
  "fr": {
    "nav": {
      "cart": "Panier",
      "locations": "Lieux",
      "home": "Accueil",
      "back": "Retour",
      "navigation": "Navigation",
      "ships": {
        "index": "Vaisseaux"
      },
      "compare": {
        "index": "Comparer",
        "ships": "Vaisseaux",
        "components": "Composants",
        "equipment": "Équipement"
      },
      "manufacturers": "Fabricants",
      "images": "Images",
      "videos": "Vidéos",
      "shipHistory": "Historique",
      "componentHistory": "Historique",
      "hangar": {
        "index": "Mon Hangar",
        "overview": "Aperçu",
        "wishlist": "Liste de souhaits",
        "stats": "Statistiques",
        "vehicleLoadouts": "Loadouts",
        "inventories": "Inventories",
        "blueprints": "Plans",
        "assets": "Actifs",
        "vehicleCargo": "Cargaison",
        "buybacks": "Rachats",
        "paints": "Peintures",
        "flair": "Décorations de hangar",
        "upgrades": "Améliorations / CCU",
        "equipment": "Équipement FPS",
        "pledgeItems": "Articles de promesse",
        "imports": "Imports",
        "transfers": "Transferts",
        "vehicleOverview": "Aperçu",
        "vehicleLog": "Journal de bord",
        "shipComponents": "Composants de vaisseau",
        "plans": "Planificateur",
        "sharedFleetchartLayout": "Disposition partagée",
        "sharedPlan": "Plan partagé"
      },
      "login": "Connexion",
      "installApp": "Installer l'app",
      "logout": "Déconnexion",
      "apiV1": "API v1",
      "apiV1Schema": "Schéma",
      "apiV1Pagination": "Pagination",
      "authApiV1": "Auth API v1",
      "authApiV1OpenId": "OpenID Connect",
      "authApiV1Schema": "Schéma",
      "embed": "Widget Intégré",
      "signUp": "S'inscrire",
      "privacyPolicy": "Politique de confidentialité",
      "impressum": "Mentions légales",
      "fleets": {
        "index": "Flottes",
        "add": "Créer une nouvelle Flotte",
        "invites": "Invitations",
        "ships": "Vaisseaux",
        "blueprints": "Plans",
        "assets": "Actifs",
        "members": {
          "index": "Members",
          "invites": "Invites",
          "worldmap": "Carte du monde",
          "starmap": "Carte stellaire",
          "health": "État"
        },
        "squadrons": {
          "index": "Escadrons",
          "overview": "Aperçu",
          "members": "Membres",
          "create": {
            "details": "Détails",
            "appearance": "Apparence",
            "discord": "Discord"
          },
          "edit": {
            "details": "Détails",
            "appearance": "Apparence",
            "discord": "Discord"
          }
        },
        "stats": "Statistiques",
        "logistics": {
          "index": "Logistics"
        },
        "shoppingLists": "Listes d'achats",
        "missions": {
          "index": "Missions",
          "edit": {
            "details": "Détails",
            "teams": "Équipes & places"
          }
        },
        "events": {
          "index": "Événements",
          "calendar": "Calendrier",
          "edit": {
            "details": "Détails",
            "schedule": "Planification",
            "signup": "Inscription",
            "teams": "Équipes & places"
          },
          "payouts": "Répartition"
        },
        "tours": "Expéditions",
        "settings": {
          "index": "Paramètres",
          "fleet": "Paramètres de Flotte",
          "rsi": "ID de flotte et RSI",
          "membership": "Paramètres d'Adhésion",
          "roles": "Rôles",
          "squadrons": "Escadrons",
          "allies": "Alliés",
          "notifications": "Notifications",
          "discord": "Discord",
          "calendar": "Calendrier",
          "features": "Fonctionnalités",
          "contracts": "Contrats"
        },
        "contracts": {
          "index": "Contrats",
          "payouts": "Paiements"
        },
        "directory": "Annuaire",
        "overview": "Aperçu"
      },
      "rsiProfile": "Profil RSI",
      "rsiHangar": "Hangar RSI",
      "tools": {
        "index": "Outils",
        "overview": "Aperçu",
        "travelTimes": "Temps de Voyage",
        "cargoGrids": "Grilles de Fret",
        "plaque": "Plaques de dédicace",
        "tradeRoutes": "Routes commerciales",
        "dressingRoom": "Cabine d'essayage",
        "paintBooth": "Atelier de peinture",
        "tours": "Expéditions"
      },
      "api": "Documentation API",
      "stats": "Statistiques",
      "toggleSlimCollapse": "Réduire",
      "toggleSlimExpand": "Développer",
      "roadmap": {
        "index": "Feuille de Route",
        "overview": "Vue d'ensemble",
        "changes": "Changements",
        "ships": "Feuille de Route des Vaisseaux"
      },
      "rsiVerification": "Vérification RSI",
      "settings": {
        "index": "Paramètres",
        "profile": "Profil",
        "account": "Compte",
        "security": "Sécurité",
        "notifications": "Notifications",
        "calendar": "Calendrier",
        "donations": "Dons",
        "hangar": "Hangar",
        "privacy": "Confidentialité",
        "features": "Fonctionnalités",
        "connections": "Connexions",
        "oauthApplications": "Apps OAuth",
        "verify": "Vérification du compte RSI",
        "friends": "Amis"
      },
      "reload": "Mise à jour disponible!",
      "visualTests": {
        "blueprints": "Plans",
        "index": "Tests Visuels",
        "panels": "Panneaux",
        "buttons": "Boutons",
        "events": "Événements",
        "typography": "Typographie",
        "forms": "Formulaires",
        "tables": "Tableaux",
        "lists": "Listes",
        "metrics": "Métriques",
        "states": "États",
        "notifications": "Notifications",
        "dedicationPlaques": "Plaques de dédicace",
        "syncModal": "Modale Sync",
        "buybackSyncModal": "Modale Sync des rachats",
        "rsiVerificationModal": "Modale de vérification RSI",
        "fleetRsiVerificationModal": "Modale de vérification RSI de la flotte",
        "overlays": "Superpositions",
        "installPrompt": "Invite d'installation",
        "supportHint": "Indicateur de soutien",
        "media": "Médias",
        "charts": "Graphiques",
        "alerts": "Alertes",
        "verifiedBadges": "Badges de vérification",
        "chips": "Chips",
        "gearStats": "Statistiques d'équipement",
        "squadrons": "Escadrons",
        "groups": {
          "foundations": "Fondations",
          "data": "Données",
          "feedback": "Retours",
          "features": "Fonctionnalités"
        },
        "notificationCenter": "Centre de notifications",
        "themes": "Thèmes"
      },
      "admin": {
        "features": {
          "overview": "Aperçu",
          "users": "Utilisateurs",
          "fleets": "Flottes",
          "history": "Historique"
        },
        "locations": {
          "index": "Lieux"
        },
        "blueprints": {
          "index": "Plans"
        },
        "missions": {
          "index": "Missions"
        },
        "index": "Admin",
        "models": {
          "index": "Modèles",
          "create": "Créer un Modèle",
          "edit": {
            "index": "Données de Base",
            "metrics": "Métriques",
            "prices": "Prix",
            "docks": "Quais",
            "modules": "Modules",
            "paints": "Peintures",
            "images": "Images",
            "videos": "Vidéos",
            "cargoAndFuel": "Fret et Carburant",
            "cargoHolds": "Soutes à cargaison",
            "fleetchart": "Images Fleetchart",
            "positions": "Postes",
            "hardpoints": "Points d'attache",
            "loaners": "Prêts",
            "snubCrafts": "Snub Crafts",
            "upgrades": "Améliorations",
            "packages": "Paquets",
            "history": "Historique"
          }
        },
        "modelPaints": {
          "index": "Peintures",
          "create": "Créer une Peinture"
        },
        "modelModules": {
          "index": "Modules",
          "create": "Créer un Module",
          "edit": {
            "index": "Données de Base",
            "models": "Modèles",
            "prices": "Prix",
            "hardpoints": "Points de Fixation",
            "docks": "Quais",
            "cargoHolds": "Soutes à cargaison",
            "history": "Historique"
          }
        },
        "unlistedModels": {
          "index": "Vaisseaux non listés"
        },
        "modelModulePackages": {
          "index": "Paquets de Modules",
          "create": "Créer un Paquet de Modules"
        },
        "components": {
          "index": "Composants",
          "edit": {
            "index": "Données de base",
            "prices": "Prix",
            "history": "Historique"
          }
        },
        "manufacturers": {
          "index": "Fabricants",
          "edit": {
            "index": "Données de base",
            "models": "Vaisseaux",
            "components": "Composants",
            "equipment": "Équipement",
            "modules": "Modules"
          }
        },
        "images": {
          "index": "Images"
        },
        "users": {
          "index": "Utilisateurs",
          "edit": "Modifier",
          "fleets": "Flottes",
          "inventories": "Inventaires",
          "supporterContributions": "Contributions"
        },
        "fleets": {
          "index": "Flottes",
          "edit": "Modifier",
          "members": "Membres",
          "history": "Historique",
          "roles": "Rôles",
          "inventories": "Inventaires"
        },
        "fleetFidClaims": {
          "index": "Réclamations de FID"
        },
        "destroyedFleets": {
          "index": "Flottes détruites"
        },
        "vehicles": {
          "index": "Véhicules"
        },
        "admins": {
          "index": "Administrateurs"
        },
        "oauthApplications": {
          "index": "Apps OAuth"
        },
        "maintenance": {
          "index": "Maintenance",
          "pghero": "PG-Hero",
          "features": "Fonctionnalités",
          "workers": "Travailleurs",
          "tasks": "Tâches",
          "imports": "Imports",
          "rsiApiStatus": "État API RSI",
          "buildCompare": "Comparer les builds"
        },
        "announcements": {
          "index": "Annonces",
          "new": "Nouvelle annonce",
          "edit": "Modifier l'annonce"
        },
        "supporterContributions": {
          "index": "Contributions des soutiens",
          "new": "Nouvelle contribution",
          "edit": "Modifier la contribution"
        },
        "fundingGoals": {
          "index": "Objectifs de financement",
          "new": "Nouvel objectif de financement",
          "edit": "Modifier l'objectif de financement"
        },
        "homepage": "Page d’accueil",
        "gameEvents": {
          "index": "Événements du jeu",
          "new": "Nouvel événement du jeu",
          "edit": "Modifier l'événement du jeu"
        },
        "notifications": {
          "index": "Notifications"
        },
        "commodities": {
          "index": "Commodities",
          "edit": {
            "index": "Base Data"
          }
        },
        "equipment": {
          "index": "Equipment",
          "edit": {
            "index": "Base Data",
            "prices": "Prices"
          }
        },
        "visualTests": {
          "index": "Tests Visuels",
          "notifications": "Notifications"
        },
        "groups": {
          "catalogue": "Catalogue",
          "community": "Communauté",
          "people": "Personnes",
          "system": "Système"
        }
      },
      "notifications": "Notifications",
      "scDataSource": "Source des données",
      "commodities": {
        "index": "Marchandises"
      },
      "components": {
        "index": "Composants"
      },
      "catalogue": {
        "commodities": "Marchandises",
        "index": "Catalogue",
        "components": "Composants",
        "blueprints": "Plans",
        "missions": "Missions",
        "equipment": "Équipement"
      },
      "equipment": {
        "index": "Équipement"
      },
      "switcher": {
        "label": "Basculer entre votre hangar et vos flottes",
        "personal": "Personnel",
        "yourFleets": "Vos flottes",
        "fleetDirectory": "Annuaire des flottes",
        "switch": "Changer"
      },
      "account": {
        "menu": "Menu du compte",
        "unread": "%{count} non lus"
      }
    }
  }
}
